import { LazyFallback } from "@msuite/ui/loading-screen";
import { Panels } from "@msuite/ui/panels";
import { lazy, Suspense } from "react";
import { SuborderShippingLabels } from "@/components/stock/suborder-shipping-labels";
import { useSuborder } from "@/hooks/use-suborder";
import type { SuborderPanelBaseProps } from "../../shared";
import { SuborderInformation } from "./suborder-information";

const Notes = lazy(() => import("@/components/notes"));

export function SuborderGeneral({ orderId, suborderId }: SuborderPanelBaseProps) {
	/** Query */
	const { suborder } = useSuborder(orderId, suborderId);

	/** Render */
	return (
		<Panels>
			<Panels.Panel
				flex={1}
				className="bottom-space"
			>
				<SuborderInformation
					orderId={orderId}
					suborderId={suborderId}
				/>
				<SuborderShippingLabels suborderId={suborderId} />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Suspense fallback={<LazyFallback variant="inline" />}>
					<Notes
						notesTable="suborderNotes"
						identifier={suborderId}
						parent={suborder}
					/>
				</Suspense>
			</Panels.Panel>
		</Panels>
	);
}
